import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52a59780"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52a59780&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a59780')) {
      api.createRecord('52a59780', component.options)
    } else {
      api.reload('52a59780', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52a59780", function () {
      api.rerender('52a59780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/index.vue"
export default component.exports